export enum ResolversEnum {
  PASSENGER_UPDATE = 'passengerUpdateData'
}

export type ResolversEnumType = keyof typeof ResolversEnum;
